<template>
  <div class="">
    <!-- CURRENT TAKT -->
    <CollapsableCategory
      :value="getHeadline"
      color="#fff"
      :is_disabled="true"
    >
    <template #content>
      <!-- v-if=" (location == 'TaktPlan' || getCurrentTaktIndex($route.params.project_id) == takt_index || !getCurrentTaktIndex($route.params.project_id) == takt_index) && (current_takt_index >= 0 && current_takt_index < taktarea.twaggons.length)" -->
        <div v-if="(current_takt_index >= 0 && current_takt_index < taktarea.twaggons.length)" class="taktarea-details-sequence-rework-waggon">
          <WorkPackageHead
            v-for="workpackage in getUObjects({
              type: 'tworkpackages',
              ids: waggons[current_takt_index].tworkpackages
            })"
            :key="`workpackages${workpackage.id}`"
            :head="{
              token: workpackage.token,
              name: workpackage.name,
              icon: workpackage.icon,
              area: taktarea.name,
              status_done_count: $store.state.Ultra.status_array.findIndex(status => status.name === workpackage.status),
              status_is_stop: workpackage.stop_status,
            }"
            location="ProjectWallet"
            :readonly="false"
            :is_taktarea_details="true"
            foreground_color="#000"
            :style="`z-index: 100; cursor: pointer; background-color: ${getColor(workpackage.color)}`"
            @click.native="$router.push({
                name: getUseOnSite ? `${location}WorkPackageWorkSteps`:`${location}WorkPackageInfo`,
                params: {
                  train_id: train.id,
                  taktarea_id: taktarea.id,
                  twaggon_id: waggons[current_takt_index].id,
                  tworkpackage_id: workpackage.id,
                  takt_index: current_takt_index + train.train_start + taktarea.taktarea_start + takt_offset,
                  direction: 'all',
                  nav_back: `${location}TaktareaDetailsInfo`
                }
              })"
              @selectStatus="
              updateUObject({
                url: [
                  {projects: $route.params.project_id},
                  {trains: train.id},
                  {taktareas: taktarea.id},
                  {twaggons: waggons[current_takt_index].id},
                  {tworkpackages: workpackage.id},
                ],
                url_suffix: $event.tooltip.toLowerCase() !== 'stop'? '/status':'/stopstatus',
                update: $event.tooltip.toLowerCase() !== 'stop'?
                {status: workpackage.status !== $event.tooltip.toLowerCase()?$event.tooltip.toLowerCase():'none'}
                :
                {stop_status: workpackage.stop_status !== 'none'?'none':'stop'}
              })
              "
              @clickStopStatus="$router.push({
                name: getUseOnSite ? `${location}WorkPackageWorkSteps`:`${location}WorkPackageInfo`,
                params: {
                  train_id: train.id,
                  taktarea_id: taktarea.id,
                  twaggon_id: waggons[current_takt_index].id,
                  tworkpackage_id: workpackage.id,
                  takt_index: current_takt_index + train.train_start + taktarea.taktarea_start + takt_offset,
                  direction: 'all',
                  nav_back: `${location}TaktareaDetailsInfo`
                }
              })"
            />
            <TText class="empty-waggon" v-if="getUObjects({
              type: 'tworkpackages',
              ids: waggons[current_takt_index].tworkpackages
            }).length === 0" value="Empty Waggon"
            />
        </div>
        <!-- v-else-if -->
        <div v-if="location == 'ProjectWallet' && getCurrentTaktIndex($route.params.project_id) != takt_index">
          You're not in the current Takttime.
        </div>
        <div v-if="current_takt_index < 0">
          Next WorkPackge in: {{ -1 * current_takt_index }} Takts
        </div>
        <div v-if="current_takt_index >= taktarea.twaggons.length">
          Last WorkPackge was: {{ current_takt_index - taktarea.twaggons.length + 1}} Takts ago
        </div>
      </template>
    </CollapsableCategory>
    <!-- DESCRIPTION -->
    <CollapsableCategory
      :value="$t('WorkpackageRework.Info.Description')"
      color="#fff"
      :is_disabled="true"
    >
      <template #content>
        <DisableableInputField
          class="mt-2 mb-2"
          label="Description"
          :value="taktarea.description"
          :is_disabled="!isEditMode"
          :background_color="'#424242'"
          :foreground_color="'#fff'"
          @change="updateUObject({
            url: [
              { projects: $route.params.project_id },
              { trains: $route.params.train_id },
              { taktareas: $route.params.taktarea_id }
            ],
            update: {
              description: $event
            }
          })"
        />
        <!-- <TText v-if="taktarea.description" small :text="taktarea.description" />
        <TText v-else small text="No description" /> -->
      </template>
    </CollapsableCategory>
    <!-- TaktArea Size -->
    <CollapsableCategory
      value="Size"
      color="#fff"
      :is_disabled="true"
    >
      <template #content>
        <DisableableInputField
          class="mt-2 mb-2"
          label="Size (m²)"
          :value="taktarea.square_meter"
          :is_disabled="!isEditMode"
          :background_color="'#424242'"
          :foreground_color="'#fff'"
          @change="updateUObject({
            url: [
              { projects: $route.params.project_id },
              { trains: $route.params.train_id },
              { taktareas: $route.params.taktarea_id }
            ],
            update: {
              square_meter: parseInt($event)
            }
          })"
        />
        {{  }}
      </template>
    </CollapsableCategory>
    <!-- SEQUENCE -->
    <CollapsableCategory
      value="Sequence"
      color="#fff"
      :is_disabled="false"
    >
      <template #content="{ is_collapsed }">
        <div v-if="is_collapsed" class="taktarea-details-sequence-rework">
          <div
            v-for="(waggon, waggon_index) in waggons"
            :key="`waggon${waggon.id}${waggon_index}`"
            class="taktarea-details-sequence-rework-waggon"
          >
            <WorkPackageHead
              v-for="workpackage in getUObjects({
                type: 'tworkpackages',
                ids: waggon.tworkpackages
              })"
              :key="`workpackages${workpackage.id}`"
              :head="{
                token: workpackage.token,
                name: workpackage.name,
                icon: workpackage.icon,
                area: taktarea.name,
                status_done_count: $store.state.Ultra.status_array.findIndex(status => status.name === workpackage.status),
                status_is_stop: workpackage.stop_status,
              }"
              location="ProjectWallet"
              :readonly="false"
              :is_taktarea_details="true"
              foreground_color="#000"
              :style="`z-index: 100; cursor: pointer; background-color: ${getColor(workpackage.color)}`"
              @click.native="$router.push({
                  name: getUseOnSite ? `${location}WorkPackageWorkSteps`:`${location}WorkPackageInfo`,
                  params: {
                    train_id: train.id,
                    taktarea_id: taktarea.id,
                    twaggon_id: waggon.id,
                    tworkpackage_id: workpackage.id,
                    takt_index: waggon_index + train.train_start + taktarea.taktarea_start + takt_offset,
                    direction: 'all',
                    nav_back: `${location}TaktareaDetailsInfo`
                  }
                })"
              @selectStatus="
              updateUObject({
                url: [
                  {projects: $route.params.project_id},
                  {trains: train.id},
                  {taktareas: taktarea.id},
                  {twaggons: waggon.id},
                  {tworkpackages: workpackage.id},
                ],
                url_suffix: $event.tooltip.toLowerCase() !== 'stop'? '/status':'/stopstatus',
                update: $event.tooltip.toLowerCase() !== 'stop'?
                {status: workpackage.status !== $event.tooltip.toLowerCase()?$event.tooltip.toLowerCase():'none'}
                :
                {stop_status: workpackage.stop_status !== 'none'?'none':'stop'}
              })
              "
              @clickStopStatus="$router.push({
                name: getUseOnSite ? `${location}WorkPackageWorkSteps`:`${location}WorkPackageInfo`,
                params: {
                  train_id: train.id,
                  taktarea_id: taktarea.id,
                  twaggon_id: waggon.id,
                  tworkpackage_id: workpackage.id,
                  takt_index: waggon_index + train.train_start + taktarea.taktarea_start + takt_offset,
                  direction: 'all',
                  nav_back: `${location}TaktareaDetailsInfo`
                }
              })"
              />
              <TText class="empty-waggon" v-if="getUObjects({
                type: 'tworkpackages',
                ids: waggon.tworkpackages
              }).length === 0" value="Empty Waggon"
            />
          </div>
        </div>
      </template>
    </CollapsableCategory>
    <!-- WIDGETS -->
    <CollapsableCategory
      :value="$t('WorkpackageRework.Info.Extras')"
      color="#fff"
      :is_disabled="true"
    >
      <template #content>
        <WorkPackageWidgetList
          :widgets="[
            { icon: 'qr-code', text: 'QR-Codes', route_name: `${location}TaktareaDetailsQRCodes`, params: {} },
            { icon: 'person-helmet', text: 'WORK.steps', route_name: `${location}TaktareaDetailsSteps`, params: { step_type: 'Work' } },
            { icon: 'tram', text: 'Sequence', route_name: `${location}TaktareaDetailsSequence`, params: {} },
            { icon: 'sign-sum', text: 'Quantities', route_name: `${location}TaktareaDetailsQuantities`, params: {} },
            { icon: 'window-new', text: 'Show TAKTarea in PROJECT.structure'},

            /* { icon: 'mdi-qrcode', text: 'QR-Codes', route_name: `${location}TaktareaDetailsQRCodes`, params: {} }, */
            /* { icon: 'mdi-account-hard-hat', text: 'WORK.steps', route_name: `${location}TaktareaDetailsSteps`, params: { step_type: 'Work' } }, */
            /* { icon: 'mdi-train', text: 'Sequence', route_name: `${location}TaktareaDetailsSequence`, params: {} }, */
          ]"
          :items_per_row="location === 'ProjectWallet' ? 4: 8"
          background_color="#fff"
          foreground_color="#fff"
          :is_small_icons="true"
          @setActive="if ($event.icon === 'visibility-on') {
            // Use Widget as Button for multiWindow
            openMultiWindow($event);
          } else {
            $router.push({
              name: $route.name.includes($event.route_name)?`${location}TaktareaDetailsInfo`:`${$event.route_name}`,
              params: $event.params
            })
          }
          "
        />
      </template>
    </CollapsableCategory>
  </div>
</template>
<script>
  import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue'
  import WorkPackageWidgetList from '@/modules/WorkPackageWIP/WorkPackageWidgetList.module.vue';
  import WorkPackageHead from '@/modules/WorkPackageWIP/WorkPackageHead.module.vue';
  import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue';

  import colors from 'vuetify/lib/util/colors';
  import { TrainTaktareaDetailsMixin } from '@/mixins/TrainTaktareaDetails.mixin.js'
  import { mapActions, mapGetters } from 'vuex';

  import { MultiWindowMixin } from '@/mixins/MultiWindow.mixin.js';

  export default {
    props: [],
    mixins: [
      TrainTaktareaDetailsMixin,
      MultiWindowMixin
    ],
    components: {
      CollapsableCategory,
      WorkPackageWidgetList,
      WorkPackageHead,
      DisableableInputField
    },
    created() {
      this.requestUObject({
        url: [
          {projects:this.$route.params.project_id},
          {trains:this.$route.params.train_id},
          {taktareas:this.$route.params.taktarea_id},
          {showWithEntitiesNormalized:''}
        ]
      })
    },
    computed: {
      ...mapGetters('Project', [
        'isEditMode'
      ]),
      getHeadline() {
        const options = { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' };
        const today = new Date().toLocaleDateString('en-GB', options).replace(/\//g, '.');
        return "Today: " + today;
      },
    },
    methods: {
      ...mapActions('Ultra', [
        'updateUObject'
      ]),
      getColor(c) {
        // --- NO COLOR PROP SPECIFIED --- ///
        if(!c) {
          return this.theme_color;
        }

        // --- HEXCOLOR --- //
        if(c[0] == '#') {
          // checks if color is a valid hexadecimal color value
          var legal_chars = /[0-9A-Fa-f]/g;
          // #FFF, #FFF8 (Opacity), #FFFFFF, #FFFFFF88 (Opacity)
          if(!(c.length == 4 || c.length == 5 || c.length == 7 || c.length == 9) || !legal_chars.test(c)) {
            return this.theme_color; // if any check fails, default to theme color
          }
          return c;
        }

        // --- VUETIFY COLOR ---//
        // references colors.js of vuetify npm module
        if (c.includes('black')) { return '#000' }
        if (c.includes('white')) { return '#FFF' }

        c = c.split(' '); // vuetify color hue and variant are seperated by ' '
        let vuetifyColor = ['red', 'base']; // vuetify colors contain color hue and variant
        for(let i = 0; i < c.length; i++) { // iterates at most two times
          let word = c[i].split('-'); // some colors and all variants are split by '-'
          if(word.length > 1) { // a '-' was used, apply camel case, turn array to string
            word = word[0] + word[1].charAt(0).toUpperCase() + word[1].slice(1); // there are at most two words
          }
          else { // otherwise turn array to string as is
            word = word[0];
          }
          vuetifyColor[i] = word;
        }

        // make sure attributes exist
        if(colors[vuetifyColor[0]] && colors[vuetifyColor[0]][vuetifyColor[1]]) {
          return colors[vuetifyColor[0]][vuetifyColor[1]];
        }
        return this.theme_color; // if color doesn't exist in vuetify, default to theme color
      },
    }
  }
</script>
<style scoped>

  .taktarea-details-sequence-rework {
    display: flex;
    width: 100%;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 15px 0px;
    height: 50vh;
  }

  .taktarea-details-sequence-rework-waggon {
    margin-bottom: 10px;
    border: 2px solid var(--v-primary-base);
    border-radius: 4px;
  }

  .taktarea-details-sequence{
    display: flex;
    width: 100%;
    overflow-x: scroll;
    padding: 15px 0px;
  }
  .taktarea-details-sequence-active-waggon {
    border-left-width: 2px;
    border-left-style: solid;
    border-left-color: snow;
    border-right-width: 2px;
    border-right-style: solid;
    border-right-color: snow;
    padding: 0px 2px;
  }

  .waggon-active {
    border-style: groove;
  }

  .empty-waggon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
  }

</style>
